import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/screens/complete-news/complete-news.tsx");
